import React from "react" 

import Main from "./components/Main" 
import Navbar from "./components/Navbar" 

import Footer from "./Footer.js"
export default function RenderTest() 
{
    return (
        <div>
            <Navbar/>
            <Main/>
            <Footer />

        </div>
    )
}

